import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Col, Badge } from "reactstrap";

import TrialRequestModel from '../../pages/Saas Onepage/trial-request';

class Pricing extends Component {
    constructor() {
        super();

        this.state = {
            modal: false
        }
        this.togglemodal = this.togglemodal.bind(this);
    }

    togglemodal = () => {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    render() {
        return (
            <React.Fragment>
                    {
                        this.props.pricings.map((pricing, key) =>
                            <Col name="pricing" lg="4" md="4" xs="12" key={key} className="mt-4 pt-2">
                                <div name="pricingbox" className={ pricing.isActive ? "pricing-rates business-rate shadow bg-white p-4 rounded" : "pricing-rates business-rate shadow bg-light p-4 rounded"}>
                                    <h2 className={pricing.isActive ? "title text-uppercase text-primary mb-4" : "title text-uppercase mb-4"}>{pricing.title}</h2>
                                    <div className="d-flex mb-4" name="pricingsection">
                                        {/* <span className="h4 mb-0 mt-1">$</span> */}
                                        <span className="price h1 mb-0">{pricing.price}</span>
                                        {/* <span className="h4 align-self-end mb-1">/{pricing.duration}</span> */}
                                    </div>
                                    
                                    <ul className="feature list-unstyled pl-0">
                                        {
                                            pricing.features.map((feature, key) =>
                                                <li key={key} className="feature-list"><i className="mdi mdi-check text-success h5 mr-1"></i>{feature.title}</li>
                                            )
                                        }
                                    </ul>
                                    <Link to="#" id="navbar-demo-download-btn" onClick={this.togglemodal} className="btn btn-outline-primary">Try Now <Badge color="danger" className="rounded ml-2">v2.0.0</Badge> </Link>
                                    {/* <Link to="" className="btn btn-primary mt-1">{pricing.buttonText}</Link> */}
                                </div>
                                <TrialRequestModel modal={this.state.modal} togglemodal={this.togglemodal} ></TrialRequestModel>

                            </Col>                        
                        )
                    }
            </React.Fragment>

        );
    }
}

export default Pricing;